// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"cc98d97d","770":"bf1ccfe7"}[chunkId] + ".chunk.css";
};